﻿import { useEffect } from 'react';

import { LicenseList } from 'pages/licenses/license_search/components/LicenseList';
import { GMetrixLoader } from 'components/GMetrixLoader/GMetrixLoader';
import { ComboLicense } from 'pages/licenses/combo_license';
import { useSearchParams } from 'react-router-dom';
import { PermissionsApi } from 'apis';
import { useSuperState } from 'hooks';
import { useIntl } from 'react-intl';

import { DefaultLayout } from '../../../components/layout';

export type LicensePermissions = {
    canAddContent: boolean;
};

export const LicenseSearch = () => {

    const { formatMessage } = useIntl();
    const [state, setState] = useSuperState({
        loading: true,
        permissions: { canAddContent: false } as LicensePermissions
    });

    const { loading, permissions } = state;

    const [searchParams, setSearchParams] = useSearchParams();

    const licenseId = searchParams.get('licenseId');

    useEffect(() => {

        const load = async () => {

            try {

                const permissions = await PermissionsApi.Get('LicenseSearch');
                setState({ loading: false, permissions });

            } catch (e) {

                console.error(e);
                setState({ loading: false });

            }

        };

        load();

    }, []);

    return (
        <DefaultLayout pageTitle={formatMessage({ id: 'licenses.11b1c36a', defaultMessage: 'Licenses' })}>
            {loading ?
                (
                    <GMetrixLoader />
                )
                :
                (
                    <>
                        {licenseId ?
                            (
                                <ComboLicense
                                    licenseId={Number(licenseId)}
                                    onBack={() => setSearchParams({})}
                                />
                            )
                            :
                            (
                                <LicenseList
                                    onEdit={id => setSearchParams({ licenseId: String(id) })}
                                    permissions={permissions}
                                />
                            )
                        }
                    </>
                )
            }
        </DefaultLayout>
    );

};
